import { authedApiFetch } from 'utils/Api';

const salesforceFundraisingsService = {
  updateFundraising: async (id, fields) => {
    return await authedApiFetch({
      endpoint: `/salesforce_fundraisings/${id}`,
      method: 'PATCH',
      payload: { fundraising: fields },
    });
  },

  convertFundraising: async (id) => {
    return await authedApiFetch({
      endpoint: `/salesforce_fundraisings/${id}/convert`,
      method: 'POST',
    });
  },

  getPicklistValues: async () => {
    return await authedApiFetch({
      endpoint: `/salesforce_fundraisings/picklist_values`,
      method: 'GET',
    });
  },
};

export default salesforceFundraisingsService;